import { render, staticRenderFns } from "./ProductSelectedOptions.vue?vue&type=template&id=5c07081c&"
import script from "./ProductSelectedOptions.vue?vue&type=script&lang=js&"
export * from "./ProductSelectedOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports